import { Injectable, signal } from '@angular/core';
import {
  DeviceTamperStatus,
  TamperLoadState,
} from '@core/types/DeviceInstallQuality';
import { RequestDevice } from '@core/types';

export interface TamperState {
  loadState: TamperLoadState;
  status: DeviceTamperStatus | null;
}

export const initialTamperState: TamperState = {
  loadState: null,
  status: null,
};

@Injectable()
export class DeviceTamperStoreService {
  private readonly state = signal<
    Record<RequestDevice['deviceHash'], TamperState>
  >({});

  getByHash(deviceHash: RequestDevice['deviceHash']): TamperState {
    return this.state()[deviceHash] ?? initialTamperState;
  }

  set(deviceHash: RequestDevice['deviceHash'], state: TamperState): void {
    this.state.update(prev => ({
      ...prev,
      [deviceHash]: state,
    }));
  }

  remove(deviceHash: RequestDevice['deviceHash']): void {
    this.state.update(prev => {
      if (!(deviceHash in prev)) {
        return prev;
      }

      const { [deviceHash]: remove, ...rest } = prev;

      return rest;
    });
  }
}
